import { Trans } from "@lingui/react/macro";
import React from "react";
import { formatDate } from "src/utils/date";
import { Language } from "src/utils/localization/languages/types";
import { ShipPageVersionFragment } from "types/graphql-types";

type ValidityDateFrom = {
  type: "ValidityDateFrom";
  date: Date;
};

type ValidityDateUntil = {
  type: "ValidityDateUntil";
  date: Date;
};
type ValidityDate = ValidityDateUntil | ValidityDateFrom;
export const versionsToValidityDates = (
  versions: ShipPageVersionFragment[],
  currentVersion: ShipPageVersionFragment
): ValidityDate[] => {
  return versions.map((v, index) => {
    if (currentVersion._key == v._key) {
      const nextVersion = versions[index + 1];
      if (!nextVersion) return { type: "ValidityDateFrom", date: v.validFrom };

      return {
        type: "ValidityDateUntil",
        date: previousDay(nextVersion.validFrom)
      };
    }

    return { type: "ValidityDateFrom", date: v.validFrom };
  });
};

const previousDay = (date: Date): Date => {
  const dateCopy = new Date(date);
  dateCopy.setDate(dateCopy.getDate() - 1);
  return dateCopy;
};

export const validityDateLabel = (date: ValidityDate, language: Language) => {
  const formattedDate = formatDate(date.date, language.ogLang, {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
  if (date.type == "ValidityDateUntil")
    return <Trans id="ship-valid-until">Util {formattedDate}</Trans>;

  return <Trans id="ship-valid-from">From {formattedDate}</Trans>;
};
